import { useEffect } from 'react';

export default function useAutoLogout(logoutFunction, delay = 300000) {
  // 300000ms is 5 minutes
  useEffect(() => {
    // Don't set up auto-logout if no logout function is provided
    if (!logoutFunction) {
      return;
    }

    let logoutTimer;
    let warningTimer;

    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];

    const showWarning = () => {
      const shouldLogout = window.confirm(
        'Your session will expire in 1 minute due to inactivity. Click OK to stay logged in, or Cancel to logout now.'
      );

      if (!shouldLogout) {
        logoutFunction();
      } else {
        // User wants to stay logged in, reset the timer
        resetTimer();
      }
    };

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);

      // Show warning 1 minute before logout
      warningTimer = setTimeout(() => {
        showWarning();
      }, delay - 60000); // 1 minute before logout

      // Set main logout timer
      logoutTimer = setTimeout(() => {
        logoutFunction();
      }, delay);
    };

    // Add event listeners
    for (let event of events) {
      window.addEventListener(event, resetTimer);
    }

    // Initialize timer
    resetTimer();

    return () => {
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      for (let event of events) {
        window.removeEventListener(event, resetTimer);
      }
    };
  }, [logoutFunction, delay]);
}
